import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Page, Layout, Card, BlockStack, Text } from '@shopify/polaris';

export const ProtectedRoute = ({ children }) => {
  const { accessToken, loading, refresh } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Page>
        <Layout>
          <Layout.Section>
            <Card>
              <BlockStack gap="loose" align="center">
                <Spinner size="large" />
                <Text variant="bodyMd" color="subdued">
                  Checking authentication...
                </Text>
              </BlockStack>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // If no access token, redirect to login
  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render children
  return children;
};
